function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
import domain_service from '@/apps/data-platform/services/master_data/domain_service';
import { ORGS } from '@/js/constants';
import { mapState } from 'vuex';
export default {
  name: 'CompaniesReportsHome',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {
      cards: [],
      data_office: '032',
      authorized_codes: ['105030', '032'],
      innova_schools_codes: ["021001", "90001", "021003", "092", "021"],
      company: null
    };
  },
  methods: {
    processOrgs: function processOrgs() {
      var _this = this;
      domain_service.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this.processCards(response.data);
        }
      });
    },
    processCards: function processCards(data) {
      var _this2 = this;
      var defaultCategory = null;
      var orgCodes = ORGS.map(function (org) {
        return org.code;
      });
      data.forEach(function (x) {
        var access = _this2.authorized_codes.includes(_this2.companyCode) || x.code === _this2.companyCode || x.code == '021' && _this2.innova_schools_codes.includes(_this2.companyCode);
        if (orgCodes.includes(x.code)) {
          var card = {
            flex: 4,
            color: '#F1F1F1',
            image: 'logo_' + x.code + '.png',
            path: '../customer_insights/companies/reports?company_code=' + x.code,
            access: access
          };
          if (access) {
            _this2.cards.unshift(card);
            if (!defaultCategory) {
              var companyData = ORGS.find(function (org) {
                return org.code === x.code;
              });
              if (companyData) {
                defaultCategory = companyData.category;
              }
            }
          } else {
            _this2.cards.push(card);
          }
        }
      });
      if (defaultCategory) {
        this.company = defaultCategory;
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.companies'),
        disabled: true,
        href: ''
      }];
    },
    getClass: function getClass() {
      if (this.filterEnabled) {
        return 'col-md-9 col-12 order-md-first order-last';
      } else {
        return 'col-12 order-md-first order-last';
      }
    },
    categories: function categories() {
      // Esta función devuelve una lista de empresas a partir de 'this.ORGS'
      return ORGS.map(function (org) {
        return org.category;
      });
    }
  }),
  watch: {
    company: function company(newVal) {
      this.cards = [];
      if (newVal) {
        var selectedCompanies = ORGS.filter(function (org) {
          return org.category === newVal;
        });
        if (selectedCompanies) {
          this.processCards(selectedCompanies);
        }
      }
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.processOrgs();
  }
};